// extracted by mini-css-extract-plugin
export default {"editor-content":"style_editor-content__Ng3vg","editor-content-container":"style_editor-content-container__4wFVK"};